<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card max-width="400" :elevation="hover ? 12 : 2" class="mx-auto" height="500">
        <v-card-title>
          <div class="d-flex justify-center align-center card-title-class">
            <div class="tabs-class">
              <v-tabs
                  v-model="tab"
              >
                <v-tab
                    v-for="(item,index) in result"
                    :key="index"
                >
              <span v-if="item">
                {{ item.label }}
              </span>
                </v-tab>
              </v-tabs>
            </div>
            <div class="refresh-class">
              <v-btn icon @click="init()">
                <v-icon>refresh</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item
                v-for="(item,index) in result"
                :key="index"
            >
              <div v-if="item.list.length !== 0">
                <div v-for="(t,i) in item.list.slice(0,12)" :key="i">
                  <v-link :index="i + 1" :title="t.title" :href="t.hasOwnProperty('url') ? t.url : t.link" :hot="t.hot"/>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import Link from '@/components/Link'
import {baidu, weibo, zhihu} from '@/api/resources/news'
import {mapMutations} from "vuex";

export default {
  name: "news",
  components: {
    'v-link': Link
  },
  data: () => ({
    tab: null,
    result: [],
  }),
  mounted() {
    this.init()
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    init() {
      this.setLoading()
      Promise.all([this._weibo(), this._baidu(), this._zhihu()]).then(([weibo, baidu, zhihu]) => {
        this.result = [
          {
            label: "微博",
            type: 'weibo',
            list: weibo
          },
          {
            label: "百度",
            type: 'baidu',
            list: baidu
          },
          {
            label: "知乎",
            type: 'zhihu',
            list: zhihu
          }
        ]
      }).finally(() => {
        this.clearLoading()
      })
    },
    _weibo() {
      return new Promise((resolve, reject) => {
        weibo().then(req => {
          resolve(req.data.data ? req.data.data : [])
        }).catch(error => {
          reject(error)
        })
      })
    },
    _baidu() {
      return new Promise((resolve, reject) => {
        baidu().then(req => {
          resolve(req.data.data ? req.data.data : [])
        }).catch(error => {
          reject(error)
        })
      })
    },
    _zhihu() {
      return new Promise((resolve, reject) => {
        zhihu().then(req => {
          resolve(req.data.data ? req.data.data : [])
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
</script>

<style scoped>
.card-title-class {
  width: 100%;
}

.tabs-class {
  width: 90%;
}

.refresh-class {
  width: 10%;
}

</style>
